module.exports = __webpack_public_path__ + "static/img/point_zd_2.7a75b8a0.png";